module.exports = __webpack_public_path__ + "static/media/close-cross-green.9b6c6047.svg";